import { api } from '@/components/Functional/lib/request'
import { logger } from '@/components/Functional/utils/logger'
import { CouponRedeemResponseSchema } from '@/schemas/v2/coupon'
import type { CouponRedeemResponse } from '@/schemas/v2/coupon'

const BASE = process.env.NEXT_PUBLIC_API_URL ?? ''

type FetchOptions = { headers?: Record<string, string> }

/**
 * POST /api/v2/coupons/{couponConfigId}
 * スポット指定クーポンの場合は spotId を指定する。
 */
export async function postCouponRedeem(
  couponConfigId: number,
  spotId?: number,
  options?: FetchOptions,
): Promise<CouponRedeemResponse> {
  const url = `${BASE}/api/v2/coupons/${couponConfigId}`
  const body = spotId != null ? { spotId } : {}
  logger.info({ fetch_method: 'POST', fetch_url: url, msg: 'fetch 開始' })
  try {
    const data = await api.post<unknown>(url, body, options)
    return CouponRedeemResponseSchema.parse(data)
  } catch (e) {
    logger.error({ fetch_method: 'POST', fetch_url: url, msg: `fetch エラー: ${String(e)}` })
    throw e
  }
}
